<template>

	<div>
		<div ref="editor"/>		
		<div style="height: 20px;"/>
	</div>
	
</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import Quill from 'quill';//'@/shift/Quill';


export default
{
	name: 'ContentFieldRichTextEditor',

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		value: '',
		editor: null,
	}),


	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		this.field.value = this.field.template.typeProperties.defaultValue;

		if (this.field.data)
		{
			const dataValue = this.field.data;

			if (dataValue)
			{
				this.field.value = dataValue;
			}
			
		}
	},

	mounted()
	{

		// ----------------------------------------------------
		//	Testing if this alt-shift line break works :o
		// ----------------------------------------------------

		this.bindings = {
			enter: {
				key: 13,
				shiftKey: true,
				handler: () =>
				{
					this.pasteHtmlAtCaret('\r');
				}
			}
		};



		// ----------------------------------------------------
		//	Toolbar options
		// ----------------------------------------------------

		var toolbarOptions = [
			['bold', 'italic', 'underline', 'strike'],        // toggled buttons
			//['blockquote', 'code-block'],

			//[{ 'header': 1 }, { 'header': 2 }],               // custom button values
			[{ 'list': 'ordered'}, { 'list': 'bullet' }],
			[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
			//[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
			//[{ 'direction': 'rtl' }],                         // text direction

			//[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
			//[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

			//[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
			//[{ 'font': [] }],
			[{ 'align': [] }],

			['clean']                                         // remove formatting button
		];



		// ----------------------------------------------------
		//	Quill editor setup
		// ----------------------------------------------------

		this.editor = new Quill(this.$refs.editor,
		{	
			modules: {
				keyboard: {
					bindings: this.bindings
				},
				toolbar: toolbarOptions
			},
			theme: 'snow',
		});

		this.editor.root.innerHTML = this.field.value;

		// We will add the update event here
		this.editor.on('text-change', () => {
			this.field.value = this.editor.getText() ? this.editor.root.innerHTML : ''
		});


		// ----------------------------------------------------
		//	Clipboard cleaning
		// ----------------------------------------------------

		this.editor.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) =>
		{
			let ops = []
			
			delta.ops.forEach(op =>
			{
				if (op.insert && typeof op.insert === 'string')
				{
					ops.push({
						insert: op.insert
					})
				}
			})
			delta.ops = ops;
			return delta;
		});

	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		
		// ----------------------------------------------------
		//	Insert breakpoint on caret position
		//	#Todo: This probably has API in Quill to do, 
		//	something about insertAt().
		// ----------------------------------------------------

		pasteHtmlAtCaret(html)
		{
			var sel, range;
			if (window.getSelection) {
				// IE9 and non-IE
				sel = window.getSelection();
				if (sel.getRangeAt && sel.rangeCount) {
					range = sel.getRangeAt(0);
					range.deleteContents();

					// Range.createContextualFragment() would be useful here but is
					// only relatively recently standardized and is not supported in
					// some browsers (IE9, for one)
					var el = document.createElement("div");
					el.innerHTML = html;
					var frag = document.createDocumentFragment(), node, lastNode;
					while ( (node = el.firstChild) ) {
						lastNode = frag.appendChild(node);
					}
					range.insertNode(frag);

					// Preserve the selection
					if (lastNode) {
						range = range.cloneRange();
						range.setStartAfter(lastNode);
						range.collapse(true);
						sel.removeAllRanges();
						sel.addRange(range);
					}
				}
			} else if (document.selection && document.selection.type != "Control") {
				// IE < 9
				document.selection.createRange().pasteHTML(html);
			}
		}
	},



	beforeDestroy()
	{
		
	},

}

</script>

